import React, { useMemo } from "react"
import type { WidgetProps } from "@rjsf/core"
import { TextInput } from "resha"

export function TextareaWidget({
    disabled,
    schema,
    value,
    autofocus,
    placeholder,
    readonly,
    onChange,
    options,
    id
}: WidgetProps) {
    const readOnly = disabled || readonly
    const examplePlaceholder = useMemo(() => {
        if (Array.isArray(schema.examples) && schema.examples.length > 0) {
            const ids = id.split("_") // in case of array items, the last value indicates the index
            const unsafeIndex = Number(ids[ids.length - 1])
            const index = isNaN(unsafeIndex) ? 0 : unsafeIndex
            return placeholder !== ""
                ? placeholder
                : String(schema.examples[index % schema.examples.length])
        }
        return placeholder
    }, [placeholder, schema, id])

    if (schema.const !== undefined) {
        return null
    }

    if (readOnly && value === undefined) {
        return <span className="text-smoke-810">No data</span>
    }

    return (
        <TextInput
            placeholder={examplePlaceholder ? `e.g. ${examplePlaceholder}` : ""}
            autoFocus={autofocus}
            readOnly={readOnly}
            value={value}
            onValueChange={onChange}
            minRows={5}
            enableCopyTextButton={options.enableCopyTextButton === true}
            enableMarkdown={options?.enableMarkdown === true}
            inputClassName="bg-transparent"
            className={`rounded-lg border border-rhino-300 ${
                readOnly ? "py-2 px-3 bg-rhino-300" : ""
            }`}
        />
    )
}
